import { useRouter } from "next/router";
import React, { useState } from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function SettingsNavigation() {
  const router = useRouter();

  const navigationItems = [
    { path: "/profile/settings", label: "Email Notification" },
    { path: "/profile/settings/manageaccount", label: "Manage Account" },
    { path: "/help", label: "Help Center" },
    { path: "/profile/settings/pricing", label: "Pricing" },
    { path: "/profile/settings/invitation", label: "Invitations" },
    { path: "/profile/settings/deleteaccount", label: "Delete Account" },
  ];
  const [slider, setSlider] = useState(false);

  return (
    <div className="text-end">
      <button
        className="p-2 rounded-md bg-white justify-center text-white lg:hidden xl:hidden z-20 "
        onClick={() => setSlider(!slider)}
      >
        <ArrowBackIcon className={`text-primary`} />
      </button>
      <div
        className={`lg:h-full xl:h-full ${
          slider ? "block" : "hidden lg:block xl:block"
        }`}
      >
        <div className="flex flex-col">
          {navigationItems.map((item) => (
            <button
              key={item.path}
              className={`text-start self-start w-[100%] p-4 hover:bg-yellow/[0.2] hover:cursor-pointer hover:text-primary ${
                router.pathname === item.path
                  ? "bg-yellow/[0.4] border-r-8 border-yellow text-primary"
                  : "text-gray-600"
              }`}
              onClick={() => {
                router.push(item.path);
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
